import './Checkbox.scss';

interface CheckboxCallbacks {
    onChange: (checked: boolean) => void;
}

type ModeType = 'white-checkbox' | 'black-checkbox' | 'white-eye' | 'black-eye';

interface CheckboxProps {
    checked: boolean;
    label: string;
    mode: ModeType;
    disabled: boolean;
}

const Checkbox = (props: CheckboxProps, callbacks: CheckboxCallbacks) => {

    let root = document.createElement('div') as HTMLDivElement;
    root.classList.add('checkbox-eye');
    root.classList.add(props.mode);

    root.innerHTML = `
        <div class="checkbox-eye-icon"></div>
        <span class="checkbox-eye-label">${props.label}</span>
    `;

    const setChecked = (checked: boolean) => {
        props.checked = checked;
        let icon_element = root.querySelector('.checkbox-eye-icon') as HTMLElement;
        if (icon_element) {
            icon_element?.classList.remove('icon-unchecked');
            icon_element?.classList.remove('icon-checked');
            if (checked) {
                icon_element?.classList.add('icon-checked');
            } else {
                icon_element?.classList.add('icon-unchecked');
            }
        } else {
            throw new Error('Element with .checkbox-eye-icon class not found in Checkbox');
        }
    }

    const isChecked = () => {
        return props.checked;
    }

    const setEnabled = (enabled: boolean) => {
        props.disabled = !enabled;
        if (enabled) {
            root.classList.remove('disabled');
            root.style.opacity = '1';
        } else {
            root.classList.add('disabled');
            root.style.opacity = '0.5';
        }
    }

    // Set event listener
    root.addEventListener('click', (e) => {
        if (!props.disabled) {
            props.checked = !props.checked;
            setChecked(props.checked);
            callbacks.onChange(props.checked);
        } else {
            e.preventDefault();
            console.info('Checkbox is disabled');
        }
    });

    // Set default value
    setChecked(props.checked);
    setEnabled(!props.disabled);

    return {
        element: root,
        setChecked,
        setEnabled,
        isChecked
    };
}

export default Checkbox;
